import { toast } from "sonner";

// Copies a coupon code; if the browser blocks the clipboard, tells the shopper to copy it by hand.
export const copyCode = async (code, okMsg) => {
  try {
    await navigator.clipboard.writeText(code);
    toast.success(okMsg || `Code ${code} copied`);
    return true;
  } catch (e) {
    console.warn("Clipboard copy failed:", e?.message || e);
    toast.error(`Couldn't copy automatically - please copy this code: ${code}`, { duration: 10000 });
    return false;
  }
};
